import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import * as localStorageUtil from "../utils/localStorage";

const enviroment = process.env.REACT_APP_ENVIROMENT;

const firebaseConfig =
  enviroment === "PRODUCTION"
    ? {
        apiKey: "",
        authDomain: "",
        databaseURL: "",
        projectId: "",
        storageBucket: "",
        messagingSenderId: "",
        appId: "",
        measurementId: ""
      }
    : {
        apiKey: "",
        authDomain: "",
        databaseURL: "",
        projectId: "",
        storageBucket: "",
        messagingSenderId: "",
        appId: "",
        measurementId: ""
      };
firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();

const googleAuthProvider = new firebase.auth.GoogleAuthProvider();
const facebookAuthProvider = new firebase.auth.FacebookAuthProvider();

const onAuthStateChange = (callback: any) => {
  return firebase.auth().onAuthStateChanged((user: any) => {
    if (user) {
      const uidLocal = localStorageUtil.load("uid");
      if (!uidLocal) {
        localStorageUtil.save("uid", user.uid);
      }
      callback({
        loggedIn: true,
        email: user.email,
        checking: false,
        photoURL: user.photoURL,
        name: user.displayName,
        uid: user.uid
      });
    } else {
      callback({ loggedIn: false });
    }
  });
};

export {
  db,
  googleAuthProvider,
  firebase,
  facebookAuthProvider,
  onAuthStateChange
};
